import React from 'react';

import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import Layout from '../../../containers/Layout';
import FormContainer from '../../../components/AddOrEditPage/FormContainer';

import { useUiContext } from '../../../context/UiContext';
import BillPaymentService from '../../../services/BillPaymentService';
import useBillPaymentForm from '../../../forms/billPayments/billPayment';

export default function AddBillPaymentPage() {
  const { showToast } = useUiContext();

  const navigate = useNavigate();

  let billPaymentForm;

  const { mutate: createBillPayment, isPending } = useMutation({
    mutationFn: (formValues) =>
      BillPaymentService.createBillPayment(formValues),
    onSuccess: (billPayment) => {
      showToast({
        text: 'Bill Payment created successfully',
        type: 'success',
      });
      billPaymentForm.formik.resetForm();
      navigate(`/bill-payments/${billPayment.id}`);
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  billPaymentForm = useBillPaymentForm({
    onSubmit: createBillPayment,
    values: null,
    alwaysEnabled: true,
    create: true,
  });

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    Create Bill Payment
                  </h1>
                </div>
              </div>

              <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
                <div className="mb-10">
                  <FormContainer
                    groupSizeOffset={10}
                    isVisible={false}
                    form={billPaymentForm}
                    noBillComId
                    isSubmitting={isPending}
                    noTitle
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
